import type { Monaco } from "../_monaco";

import { getAdjacentFocusable } from "./_next-focusable";

function focusAdjacent(editor: Monaco.editor.IStandaloneCodeEditor, direction: 1 | -1): void {
	if (document.activeElement != null) {
		getAdjacentFocusable(document.activeElement, direction, editor.getDomNode() ?? undefined)?.focus();
	}
}

export function moveFocusOnTab(monaco: typeof Monaco, editor: Monaco.editor.IStandaloneCodeEditor): VoidFunction {
	const focusNext = editor.addAction({
		id: "move-focus-next",
		label: "Move Focus to Next Element",
		keybindings: [monaco.KeyCode.Tab],
		keybindingContext: "editorTextFocus && !editorTabMovesFocus && !suggestWidgetVisible",
		run: () => focusAdjacent(editor, 1),
	});

	const focusPrev = editor.addAction({
		id: "move-focus-previous",
		label: "Move Focus to Previous Element",
		// biome-ignore lint/suspicious/noBitwiseOperators: Standard way of specifying mod + key bind in Monaco
		keybindings: [monaco.KeyMod.Shift | monaco.KeyCode.Tab],
		keybindingContext: "editorTextFocus && !editorTabMovesFocus && !suggestWidgetVisible",
		run: () => focusAdjacent(editor, -1),
	});

	return () => {
		focusNext.dispose();
		focusPrev.dispose();
	};
}
